export default __webpack_public_path__ + "images/withoutSecure_54478f.svg";